<template>
      <div id="plan-options">
            <section class="section plan-options-hero animate__animated animate__fadeIn">
                  <BackButton link="/choose-plan" />
                  <div class="grid-container max">
                        <div class="plan-options-grid">
                              <div class="plan-options-left">
                                    <h1>Both HMO and HRA plan options feature flexibility and savings</h1>
                              </div>
                              <div class="plan-options-right">
                                    <p class="plan-options-desc">All Anthem Plan Options include access to a wide range of personalized solutions designed to help you and your family have confidence and control in your health.</p>
                                    <div class="plan-options-section">
                                          <h5>Find your best care</h5>
                                          <ul>
                                                <li>Direct access to specialists, no referrals needed</li>
                                                <li>24/7 access to in-network providers via LiveHealth Online<sup>1</sup></li>
                                                <li>Access to our national network of doctors, and even some doctors outside of the U.S.</li>
                                          </ul>
                                    </div>
                                    <div class="plan-options-section">
                                          <h5>Create your savings</h5>
                                          <ul>
                                                <li>You and your covered spouse can each earn up to 480 points (a total of up to 960 points) by completing certain health actions. You can redeem these points as credits to apply toward eligible medical and pharmacy expenses<sup>2</sup></li>
                                                <li>You can rollover unused credits from your 2026 SHBP health plan, if you have any remaining</li>
                                          </ul>
                                    </div>
                                    <div class="plan-options-section">
                                          <h5>Maintain your health</h5>
                                          <ul>
                                                <li>Eligible preventive care is covered at 100% when you see an in-network provider<sup>3</sup></li>
                                                <li>Anthem health experts are available at no extra cost to help you and covered members of your family manage chronic conditions</li>
                                                <li>On-the-go access to your health plan via the Sydney<sup>SM</sup> Health mobile app</li>
                                          </ul>
                                    </div>
                              </div>
                        </div>
                        <p class="plan-options-footnote">1 LiveHealth Online is the trade name of Health Management Corporation, a separate company providing telehealth services on behalf of Anthem Blue Cross and Blue Shield. 2 Completing your well-being incentive actions with Sharecare will earn you points. You can choose to redeem these points for well-being incentive credits to use on covered medical and pharmacy expenses or the Visa Prepaid Card option. Visit <a href="https://BeWellSHBP.com" target="_blank">BeWellSHBP.com</a> for more information. 3 Services must be properly coded as preventive care under the Patient Protection and Affordable Care Act.</p>
                  </div>
                  <div class="plan-options-btn-wrap">
                        <router-link to="/compare" class="plan-options-btn"><span>Next</span></router-link>
                  </div>
            </section>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      export default {
            name: "SHBPPlanOptions",
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            }
      }
</script>

<style lang="scss">
#plan-options {
      .plan-options-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 160px 0;
            position: relative;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .plan-options-grid {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: flex-start;
                  justify-content: space-between;
                  gap: 64px;
                  margin-top: 48px;
            }

            .plan-options-left {
                  flex: 1 1 400px;
                  max-width: 560px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(2.75rem, 4.5vw, 4.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 0;
                  }
            }

            .plan-options-right {
                  flex: 1 1 480px;
                  max-width: 620px;

                  .plan-options-desc {
                        color: #12130f;
                        font-size: 1.125rem;
                        font-weight: 600;
                        line-height: 1.5;
                        margin-bottom: 32px;
                  }

                  .plan-options-section {
                        margin-bottom: 28px;

                        &:last-child {
                              margin-bottom: 0;
                        }

                        h5 {
                              color: #1355E9;
                              font-weight: 700;
                              font-size: 1.125rem;
                              margin-bottom: 8px;
                        }

                        ul {
                              margin: 0;
                              padding: 0 0 0 1.125rem;

                              li {
                                    color: #3F3A4E;
                                    font-size: 1rem;
                                    line-height: 1.5;
                                    margin-bottom: 8px;

                                    &:last-child {
                                          margin-bottom: 0;
                                    }
                              }
                        }
                  }
            }

            .plan-options-footnote {
                  color: #6b6b6b;
                  font-size: 0.75rem;
                  line-height: 1.6;
                  margin-top: 48px;
                  margin-bottom: 0;

                  a {
                        color: #1355E9;
                        text-decoration: underline;
                  }
            }

            .plan-options-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  background-color: #ffffff;
                  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
                  padding: 20px 0;
                  text-align: center;
            }

            .plan-options-btn {
                  display: block;
                  background-color: #1355E9;
                  color: #ffffff !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 330px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;
                  margin: 0 auto;

                  &:hover {
                        background-color: #44B8F3;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 140px 24px;

                  .back-btn {
                        left: 2rem;
                  }

                  .plan-options-grid {
                        flex-direction: column;
                        gap: 32px;
                        margin-top: 32px;
                  }

                  .plan-options-left {
                        flex: 0 0 auto;
                        max-width: 100%;

                        h1 {
                              font-size: clamp(2rem, 8vw, 3rem) !important;
                        }
                  }

                  .plan-options-right {
                        flex: 0 0 auto;
                        max-width: 100%;
                  }
            }
      }
}
</style>
